var _construct = require("C:\\Users\\ktroe\\git\\firedrum\\lib\\firedrum-react-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/construct");

var _classCallCheck = require("C:\\Users\\ktroe\\git\\firedrum\\lib\\firedrum-react-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\ktroe\\git\\firedrum\\lib\\firedrum-react-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/* globals fetch, Headers */

/* istanbul ignore next */
if (!process.browser) {
  global.fetch = require('node-fetch');
  global.Headers = global.fetch.Headers;
}

var caseless = require('caseless');

var toTypedArray = require('typedarray-to-buffer');

var makeHeaders = function makeHeaders(obj) {
  return new Headers(obj);
};

var makeBody = function makeBody(value) {
  // TODO: Streams support.
  if (typeof value === 'string') {
    value = Buffer.from(value);
  }
  /* Can't test Blob types in Node.js */

  /* istanbul ignore else */


  if (Buffer.isBuffer(value)) {
    value = toTypedArray(value);
  }

  return value;
};

var R2 =
/*#__PURE__*/
function () {
  "use strict";

  function R2() {
    var _this = this;

    _classCallCheck(this, R2);

    this.opts = {
      method: 'GET'
    };
    this._headers = {};
    this._caseless = caseless(this._headers);

    var failSet = function failSet() {
      throw new Error('Cannot set read-only property.');
    };

    var resolveResWith = function resolveResWith(way) {
      return function (resp) {
        return resp.clone()[way]();
      };
    };
    /* formData isn't implemented in the shim yet */


    var ways = ['json', 'text', 'arrayBuffer', 'blob', 'formData'];
    ways.forEach(function (way) {
      return Object.defineProperty(_this, way, {
        get: function get() {
          return _this.response.then(resolveResWith(way));
        },
        set: failSet
      });
    });

    this._args.apply(this, arguments);

    this.response = Promise.resolve().then(function () {
      return _this._request();
    });
  }

  _createClass(R2, [{
    key: "_args",
    value: function _args() {
      var opts = this.opts;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (typeof args[0] === 'string') {
        opts.url = args.shift();
      }

      if (typeof args[0] === 'object') {
        opts = Object.assign(opts, args.shift());
      }

      if (opts.headers) this.setHeaders(opts.headers);
      this.opts = opts;
    }
  }, {
    key: "method",
    value: function method(verb) {
      this.opts.method = verb.toUpperCase();

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this._args.apply(this, args);

      return this;
    }
  }, {
    key: "_request",
    value: function _request() {
      var url = this.opts.url;
      delete this.opts.url;

      if (this.opts.json) {
        this.opts.body = JSON.stringify(this.opts.json);
        this.setHeader('content-type', 'application/json');
        delete this.opts.json;
      }

      if (this.opts.body) {
        this.opts.body = makeBody(this.opts.body);
      } // TODO: formData API.


      this.opts.headers = makeHeaders(this._headers);
      return fetch(url, this.opts);
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(obj) {
      for (var key in obj) {
        this._caseless.set(key, obj[key]);
      }

      return this;
    }
  }, {
    key: "setHeader",
    value: function setHeader(key, value) {
      var o = {};
      o[key] = value;
      return this.setHeaders(o);
    }
  }]);

  return R2;
}();

module.exports = function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return _construct(R2, args);
};

module.exports.put = function () {
  var _ref;

  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return (_ref = new R2()).method.apply(_ref, ['put'].concat(args));
};

module.exports.get = function () {
  var _ref2;

  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return (_ref2 = new R2()).method.apply(_ref2, ['get'].concat(args));
};

module.exports.post = function () {
  var _ref3;

  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  return (_ref3 = new R2()).method.apply(_ref3, ['post'].concat(args));
};

module.exports.head = function () {
  var _ref4;

  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  return (_ref4 = new R2()).method.apply(_ref4, ['head'].concat(args));
};

module.exports.patch = function () {
  var _ref5;

  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  return (_ref5 = new R2()).method.apply(_ref5, ['patch'].concat(args));
};

module.exports.delete = function () {
  var _ref6;

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  return (_ref6 = new R2()).method.apply(_ref6, ['delete'].concat(args));
};